<template>
  <el-drawer
    title
    :visible="drawer"
    size="400px"
    ref="drawer"
    @open="open"
    :before-close="cancelDrawer"
    class="image-detail"
  >
    <div class="drawer-cart-box">
      <div class="drawer-content-box" :style="{ height: fullHeight + 'px' }">
        <div class="overflow">
          <i class="el-icon-close close" @click="closeDrawer"></i>
          <div
            class="image-box"
            @click="openReview"
            :class="{ play: isVideo, security: detail.isSecrecy }"
          >
            <i class="label" v-show="detail.fileSuf === 'gif'">GIF</i>
            <img v-show="!isVideo" :src="detail.filePath" alt />
            <img v-show="isVideo" :src="detail.fileThumbnailPath" alt />
          </div>
          <div class="title-box">
            <h4 class="title" @click="editImageName" v-show="!isEdit">{{ detail.fileDescription }}</h4>
            <input
              v-show="isEdit"
              class="el-input__inner"
              type="text"
              v-model="imageName"
              @input="searchLabel"
              placeholder="请输入文件名"
            />
            <p v-show="isEdit" @click="changeFileName">确定</p>
          </div>

          <div class="search-box">
            <input
              class="el-input__inner"
              type="text"
              v-model="keyWords"
              @input="searchLabel"
              placeholder="创建或搜索标签"
            />
            <div
              class="search-detail"
              v-show="isSearch"
              ref="searchDetail"
              tabindex="-1"
              @blur="closeDetail"
            >
              <div
                class="label-item"
                @click="createLabel"
                v-show="searchList.length === 0"
              >创建“{{ keyWords }}”标签</div>
              <div
                class="label-item"
                @click="addLabel(item, true)"
                v-for="(item, index) in searchList"
                :key="index"
              >{{ item.name }}</div>
            </div>
          </div>

          <dl>
            <dt>常用标签</dt>
            <dd
              class="label-item"
              @click="addLabel(item, index)"
              v-for="(item, index) in labelList"
              :key="index"
            >{{ item.name }}</dd>
          </dl>

          <div class="label-main">
            <h5 class="title">已添加</h5>
            <div class="label-list">
              <div
                class="label-item remove-item"
                v-for="(item, index) in addLabelList"
                :key="index"
              >
                {{ item.name }}
                <i @click="removeLabel(index)"></i>
              </div>
              <div class="none" v-show="addLabelList.length === 0">暂无已添加的标签</div>
            </div>
          </div>
          <div class="tools">
            <el-button type="primary" size="small" @click="saveLabel">保 存</el-button>
          </div>
          <div class="image-info">
            <h5 class="title">基本信息</h5>
            <div class="info-item">
              <b>评分</b>
            </div>
            <div class="info-item" v-show="detail.fileWidth">
              <b>尺寸</b>
              <p>{{ detail.fileWidth }} x {{ detail.fileHtight }}</p>
            </div>
            <div class="info-item">
              <b>文件大小</b>
              <p>{{ (detail.fileSize / 1024).toFixed(2) }} KB</p>
            </div>
            <div class="info-item">
              <b>类型</b>
              <p>{{ detail.fileSuf }}</p>
            </div>
            <div class="info-item">
              <b>上传日期</b>
              <p>{{ detail.createTime }}</p>
            </div>
            <div class="info-item">
              <b>保密状态</b>
              <p>
                {{ detail.isSecrecy ? '保密' : '公开' }}
                <a @click="adjustSecurity">调整</a>
              </p>
            </div>
            <div class="info-item" v-if="detail.file_secrecy">
              <b>截止时间</b>
              <p>{{ detail.file_secrecy.type === 0 ? '永久' : detail.file_secrecy.secrecyEndTime}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mask" v-if="videoReviewShow" @click="videoReviewShow = false">
      <div class="review-box" @click.stop="stop">
        <h3 class="title">视频预览</h3>
        <i class="el-icon-close" @click="videoReviewShow = false"></i>
        <video :src="detail.filePath" controls autoplay></video>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import {
  getUseLabelList,
  searchLabelList,
  fileAddLabel,
  addLabel,
  changeFileName
} from "../assets/js/api";
import { PromiseWidget } from "../assets/js/tools";
export default {
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  watch: {},
  data() {
    return {
      videoReviewShow: false,
      keyWords: "",
      labelList: [],
      isSearch: false,
      searchTimeout: null,
      searchList: [],
      addLabelList: [],
      VideoSuffixList: ["mov", "mp4", "avi", "mkv"],
      isVideo: false,
      fullHeight: "",
      isEdit: false,
      imageName: ""
    };
  },
  created() {
    this.isEdit = false;
    this.getUseLabelList();
  },
  mounted() {
    this.fullHeight = document.documentElement.clientHeight;
  },
  methods: {
    adjustSecurity() {
      this.$emit("wakeAdjust");
    },
    stop() {},
    async changeFileName() {
      const params = {
        id: this.detail.id,
        file_description: this.imageName
      };
      const [err, data] = await PromiseWidget.to(changeFileName(params));
      if (data.code === 200) {
        this.$emit("update-file");
        this.isEdit = false;
        this.$message.success("更改文件名称成功");
        this.detail.fileName = this.imageName;
      }
    },
    editImageName() {
      this.isEdit = true;
      this.imageName = this.detail.fileDescription;
    },
    openReview() {
      this.videoReviewShow = this.isVideo;
    },
    async createLabel() {
      const params = {
        group_id: 0,
        label_name: this.keyWords
      };
      const [err, data] = await PromiseWidget.to(addLabel(params));
      if (data.code === 200) {
        this.$message.success("新增标签成功");
        this.searchLabel();
        this.getUseLabelList();
      }
    },
    removeLabel(index) {
      this.addLabelList.splice(index, 1);
    },
    async saveLabel() {
      const temp = [];
      this.addLabelList.map(item => {
        temp.push(item.id);
      });
      const params = {
        file_id: this.detail.id,
        label_ids: temp
      };

      if (temp.length === 0) {
        this.$message.error("已添加标签不能为空");
      } else {
        const [err, data] = await PromiseWidget.to(fileAddLabel(params));
        if (data.code === 200) {
          this.$message.success("保存成功");
          this.closeDrawer();
        }
      }
    },
    addLabel(item, type) {
      const temp = this.addLabelList.filter(it => it.id === item.id);
      temp.length === 0 && this.addLabelList.push(item);
      type && ((this.isSearch = false), (this.keyWords = ""));
    },
    closeDetail() {
      this.isSearch = false;
    },
    searchLabel() {
      window.clearTimeout(this.searchTimeout);
      this.searchTimeout = window.setTimeout(async () => {
        if (this.keyWords) {
          this.isSearch = true;
          const [err, data] = await PromiseWidget.to(
            searchLabelList(this.keyWords)
          );

          this.searchList = data.data;
          this.$refs.searchDetail.focus();
        }
      }, 500);
    },
    async getUseLabelList() {
      const [err, data] = await PromiseWidget.to(getUseLabelList());
      if (data.code === 200) {
        this.labelList = data.data;
      }
    },
    open() {
      this.addLabelList = this.detail.labels;
      this.keyWords = "";
      this.isVideo = this.VideoSuffixList.includes(
        this.detail.fileSuf.toLowerCase()
      );
    },
    calc() {},
    // 关闭抽屉
    closeDrawer() {
      this.$emit("closeDrawer");
    },
    // 取消
    cancelDrawer() {
      this.closeDrawer();
    }
  }
};
</script>
<style lang="scss" scoped>
.drawer-cart-box {
  height: 100%;
  .drawer-content-box {
    position: relative;
    height: 100%;
    overflow-y: auto;
    padding: 20px;
    box-sizing: border-box;

    .el-icon-close.close {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
    }

    .image-box {
      width: 300px;
      height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      position: relative;

      &.security:before {
        content: " ";
        position: absolute;
        right: 0;
        top: 0;
        width: 60px;
        height: 60px;
        background: url(../assets/images/lock-icon.png) no-repeat center center
          rgba(0, 0, 0, 0.5);
      }

      i.label {
        font-size: 12px;
        color: #fff;
        font-style: normal;
        background-color: #ff6029;
        padding: 0 4px;
        height: 16px;
        line-height: 16px;
        position: absolute;
        left: 6px;
        top: 6px;
      }
      &.play {
        cursor: pointer;
        &:after {
          position: absolute;
          left: 125px;
          top: 125px;
          width: 50px;
          height: 50px;
          background: url(../assets/images/video-play-icon.png) no-repeat;
          content: " ";
        }
      }
      img {
        display: block;
        max-width: 100%;
        max-height: 100%;
      }

      video {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .title-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #dcdfe6;
      margin: 20px 0 0;

      p {
        margin: 0 0 0 10px;
        color: #1983f9;
        width: 40px;
        cursor: pointer;
      }

      .el-input__inner {
        z-index: 4;
        height: 32px;
        line-height: 32px;
      }
    }
    h4.title {
      color: #000;
      font-size: 14px;
      font-weight: 400;
      padding: 10px 40px 10px 10px;
      line-height: 26px;
      background-color: #f6f7f9;
      position: relative;
      cursor: pointer;
      margin: 0;
      flex: 1;
      word-break: break-all;
      &:after {
        width: 16px;
        height: 16px;
        content: " ";
        background: url(../assets/images/edit-icon.png) no-repeat center center;
        position: absolute;
        top: 50%;
        margin-top: -8px;
        right: 10px;
      }
    }

    .search-box {
      position: relative;
      padding: 10px 0 0;

      .el-input__inner {
        position: relative;
        z-index: 4;
        height: 32px;
        line-height: 32px;
      }
      .search-detail {
        position: absolute;
        left: 0;
        top: 51px;
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        box-shadow: 0px 2px 4px rgba(76, 83, 91, 0.1);
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        z-index: 3;
        background-color: #fff;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        height: 360px;
        overflow-y: auto;
        outline: none;
      }
    }

    dl,
    .label-main {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
    }
    dt,
    h5.title {
      width: 100%;
      color: #303133;
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      margin: 0 0 10px;
    }

    .label-main {
      .label-list {
        background-color: #f6f7f9;
        padding: 10px;
        box-sizing: border-box;
        width: 100%;
        border-radius: 5px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
      }
    }

    .none {
      padding: 20px 0;
      text-align: center;
      color: #909399;
      width: 100%;
    }

    .label-item {
      height: 22px;
      padding: 0 10px;
      border: 1px solid #bfbfbf;
      background-color: #f8f8f8;
      margin: 0 10px 6px 0;
      border-radius: 5px;
      line-height: 20px;
      box-sizing: border-box;
      font-size: 12px;
      color: #606266;
      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &.remove-item {
        padding-right: 3px;
      }
      &:hover {
        border: 1px solid #1983f9;
        i {
          background-color: #dcdfe6;
          border-radius: 50%;
        }
      }

      i {
        width: 14px;
        height: 14px;
        margin-left: 3px;
        background: url(../assets/images/label-remove-icon.png) no-repeat center
          center;
      }
    }

    .image-info {
      padding-top: 10px;

      .info-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        b,
        p {
          font-size: 14px;
          font-weight: 400;
          color: #606266;
          margin: 0;

          a {
            color: #1983f9;
            margin-left: 10px;
            cursor: pointer;
          }
        }
      }
    }

    .tools {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 10px 0;
      border-bottom: 1px solid #dcdfe6;
    }
  }
}
.mask {
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1999;
  .review-box {
    padding: 20px 50px 50px;
    max-width: 800px;
    max-height: 80vh;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;
    h3.title {
      color: #606266;
      font-size: 16px;
      margin: 0;
      font-weight: 400;
      padding-bottom: 30px;
    }

    video {
      max-width: 100%;
      max-height: calc(80vh - 118px);
      outline: none;
    }

    i {
      cursor: pointer;
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }
}
</style>